import { createFileRoute } from '@tanstack/react-router';
import { UsersListPage } from '@pages/users';

/** Personen-Nutzer-Route (/persons/users) — Nur Clerk-Nutzer */
export const Route = createFileRoute('/_authenticated/persons/users')({
  component: () => <UsersListPage filterClerkOnly={true} />,
});
